import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { QuestionnaireService } from '../services/questionnaire.service';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormArray } from '@angular/forms';
import { mixtureComponent } from '../mixture/mixture.component';
import { Draft } from '../services/draft.service';
@Component({
	selector: 'app-loan-details',
	templateUrl: './loan-details.component.html',
	styleUrls: ['./loan-details.component.scss']
})
export class LoanDetailsComponent implements OnInit {
	private route$: Subscription;
	private _herkevSub: Subscription;
	qID;
	prevQID: any;
	currentStep;
	visibleQids;
	questionId = 0;
	optionsPurpose;
	selectedOptionPurpose;
	optionsOwnership;
	selectedOptionOwnership;
	currentStepName;
	loanDetails: FormGroup;
	submitted;
	editQuestion;
	maslulimJson: any;
	userName;
	numberYears: string[] = ['10', '15', '20', '25', '30'];
	warnInfo = false;
	isEdit;
	isAdvisor = false;
	qFields = {
		1: [{ name: "loanPurpose", validators: [] }],
		'1.1': [{ name: "loanPurposeDetails", validators: [Validators.required, Validators.pattern("^[A-Za-zא-ת\ ]*$")] }],
		2: [{ name: "howMuchYouNeed", validators: [Validators.required, Validators.min(1000)] }],
		'2.0': [{ name: "zakaut", validators: [Validators.required] }],
		'2.1': [{ name: "scumZakaut", validators: [Validators.required, this.scumZakautValidator()] }],
		'2.2': [{ name: "tkufa", validators: [Validators.required] }],
		'2.3': [{ name: "herkevGeneri", validators: [Validators.required] }],
		'2.4': [{ name: "Mixture", validators: [this.checkAmount(),this.periodValidator(), this.fixedMinThirdValidator()], type: "Mixture" }],
		3: [{ name: "haveOneYet", validators: [Validators.required, this.canOverValidator("haveOneYet")] }],
		4: [{ name: "forThePropertyYouOwn", validators: [Validators.required] }],
		5: [{ name: "doYouIntendToSellIt", validators: [Validators.required] }],
		6: [{ name: "itsMehirLemishtaken", validators: [Validators.required] }],
		7: [
			{ name: "propertValue", validators: [Validators.required, this.amountValidator("propertValue")] },
			{ name: "apartmentCost", validators: [Validators.required] }
		]
	};

	qArrFields = {
		'2.4': [
			{ name: "type", validators: [Validators.required] },
			{ name: "amount", validators: [Validators.required] },
			{ name: "period", validators: [Validators.required, Validators.min(48), Validators.max(360), this.checkZero(), Validators.pattern("^[1-9][0-9]*$")] },
			// { name: "ribit", validators: [Validators.required] } valid inside mixture-row

		]
	};
	constructor(
		private questionnaireService: QuestionnaireService,
		private activeRoute: ActivatedRoute,
		private router: Router,
		public translate: TranslateService,
		private draft: Draft,
		private fb: FormBuilder,
		private _changeDetector: ChangeDetectorRef,
	) {

	}

	ngOnInit() {
		this.isAdvisor = this.questionnaireService.getIsAdvisor();
		this.questionnaireService.getMaslulim().subscribe(data => {
			this.maslulimJson = data;
		});
		this.createForm();
		let stepUserDetails = this.questionnaireService.getStep("user-details");
		this.userName = this.questionnaireService.getQuestion(stepUserDetails, "1").answer.fields[0].answerValue || "userName"

		this.optionsPurpose = [
			{ label: 'LOAN_DETAILS.Q1.A1', id: "1", class: "key" },
			{ label: 'LOAN_DETAILS.Q1.A2', id: "2", class: "home" },
			{ label: 'LOAN_DETAILS.Q1.A3', id: "17", class: "renovation" },
			{ label: 'LOAN_DETAILS.Q1.A4', id: "10", class: "plot" },
			{ label: 'LOAN_DETAILS.Q1.A5', id: "5", class: "selfbuild" },
			{ label: 'LOAN_DETAILS.Q1.A6', id: "7", class: "expansion" },
			{ label: 'LOAN_DETAILS.Q1.A7', id: "11", class: "all" }

		];

		this.optionsOwnership = [
			{ label: 'LOAN_DETAILS.Q4.A1', id: "forExistingProperty" },
			{ label: 'LOAN_DETAILS.Q4.A2', id: "forAcquiredAsset" }
		];

		this.selectedOptionPurpose = "3";
		this.selectedOptionOwnership = "1";

		this.route$ = this.activeRoute.params.subscribe(params => {
			console.log("-----------------------------> params", params);
			this.prevQID = this.qID;
			this.qID = params.qid;
			this.editQuestion = null;
			this.currentStepName = "loan-details";

			if (params.qid === "all") {
				this.isEdit = true;
				//this.visibleQids = "all";
				//this.visibleQids = [1,3,4];
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
				this.clearPreviousQuestionValidators();
			} else {
				this.isEdit = false;
				this.setValidators();
				this.setValidatorsArray();
				//this.visibleQids = null;
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
			}
		});
		if (this.draft.autoForm) {
			this.loanDetails = this.draft.buildForm(this.currentStep, this.loanDetails);
		}
		this.draft.isAfterStep1 = true;		
	}
	  
	createForm() {
		this.currentStep = this.questionnaireService.getStep("loan-details");
		this.loanDetails = this.fb.group({
			loanPurpose: this.questionnaireService.getQuestion(this.currentStep, "1").selectedAnswer,
			loanPurposeDetails: this.questionnaireService.getQuestion(this.currentStep, "1.1").selectedAnswer,
			howMuchYouNeed: this.questionnaireService.getQuestion(this.currentStep, "2").answer.fields[0].answerValue,
			zakaut: this.questionnaireService.getQuestion(this.currentStep, "2.0").selectedAnswer,
			scumZakaut: this.questionnaireService.getQuestion(this.currentStep, "2.1").answer.fields[0].answerValue,
			tkufa: this.questionnaireService.getQuestion(this.currentStep, "2.2").answer.fields[0].answerValue,
			herkevGeneri: this.questionnaireService.getQuestion(this.currentStep, "2.3").selectedAnswer === "" ? '1' : this.questionnaireService.getQuestion(this.currentStep, "2.3").selectedAnswer,
			Mixture: mixtureComponent.build(this.questionnaireService.getQuestion(this.currentStep, "2.4").answer.fieldsArray),
			haveOneYet: this.questionnaireService.getQuestion(this.currentStep, "3").selectedAnswer,
			forThePropertyYouOwn: this.questionnaireService.getQuestion(this.currentStep, "4").selectedAnswer,
			doYouIntendToSellIt: this.questionnaireService.getQuestion(this.currentStep, "5").selectedAnswer || '',
			itsMehirLemishtaken: this.questionnaireService.getQuestion(this.currentStep, "6").selectedAnswer,
			propertValue: this.questionnaireService.getQuestion(this.currentStep, "7").answer.fields[0].answerValue,
			apartmentCost: this.questionnaireService.getQuestion(this.currentStep, "7").answer.fields[1].answerValue,
			
		});
	}

	setValidators() {
		// if (this.prevQID) {
		this.clearPreviousQuestionValidators();
		// }
		for (let i = 0; i < this.qFields[this.qID].length; i++) {
			let field = this.qFields[this.qID][i];
			this.loanDetails.controls[field.name].setValidators(field.validators);
			this.loanDetails.controls[field.name].updateValueAndValidity();
		}
		this.submitted = false;
	}

	setValidatorsArray() {
		this.questionnaireService.clearAllQuestionValidators(this.loanDetails.controls, this.qFields, this.qArrFields);
		this.questionnaireService.setCurrentQuestionValidators(this.qID, this.loanDetails.controls, this.qFields, "2", this.qArrFields);
		this.submitted = false;
	}

	scumZakautValidator() {
		return (control): { [key: string]: any } => {
			let scumZakaut = this.loanDetails.controls["scumZakaut"].value;
			let howMuchYouNeed = this.loanDetails.controls["howMuchYouNeed"].value;
			if (scumZakaut > howMuchYouNeed) {
				return { scumZakautError1: true };
			}
			if (scumZakaut > 350000) {
				return { scumZakautError2: true };
			}

			if (scumZakaut < 360) {
				return { scumZakautError3: true };
			}
		}
	}

	clearPreviousQuestionValidators() {
		console.log("clearPreviousQuestionValidators()");

		let keys = Object.keys(this.qFields);

		for (let i = 0; i < keys.length; i++) {

			for (let j = 0; j < this.qFields[keys[i]].length; j++) {
				this.loanDetails.controls[this.qFields[keys[i]][j].name].setValidators(null);
				this.loanDetails.controls[this.qFields[keys[i]][j].name].updateValueAndValidity();
			}
		}
	}

	openWebSite(code) {
		if (code === 1) {
			window.open("https://www.gov.il/he/departments/guides/mortgage_guide?chapterIndex=1");
		}
		if (code === 2) {
			window.open("https://www.gov.il/he/departments/guides/mortgage_guide?chapterIndex=1");
		}
	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit", "value=", value, ", valid=", valid);
		this.submitted = true;
		const herkevGeneri = this.loanDetails.get('herkevGeneri');
		let submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;
		if (herkevGeneri.value === '1' && submitQID === '2.4') {
			valid = true;
		}
		if (!valid) {
			this.questionnaireService.submitForm(true);
		}
		else {
			this.questionnaireService.submitForm(false);
		}
		if (valid) {
			let q;
			submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;

			q = this.qFields[submitQID];

			let values = q.map(r => {
				return value[r.name];
			});

			var loanPurpose = null;

			if (this.loanDetails.get('loanPurpose')) {
				loanPurpose = this.loanDetails.get('loanPurpose').value;
			}

			if (loanPurpose !== null && ["10", "11", "17"].indexOf(loanPurpose.toString()) !== -1) {
                this.loanDetails.patchValue({
                scumZakaut: null,
                zakaut: "NO"
                });
                value["scumZakaut"] = "";
                value["zakaut"] = "NO";
}

			if (loanPurpose === '11') {
				this.loanDetails.get('herkevGeneri').setValue('2');
			}
			if (submitQID === '2.4') {
				// values[0].array.forEach(element => {
				// 	element.type
				// });

				const mix = Array.isArray(value.Mixture) ? value.Mixture : [];

				mix.forEach(element => {
					const filteredArray = this.maslulimJson.filter(item => item["TEUR_MASLUL"] === element.type);
					if (filteredArray.length > 0) {
					element.type = filteredArray[0]['KOD_MASLUL'] + "&" + filteredArray[0]['TEUR_MASLUL'];
				}
			});

				values[0] = mix;
				this.draft.buildArrDraft('2.3', this.qFields, value, this.currentStep, this.isEdit)
				if (herkevGeneri.value !== '1') {
					this.draft.buildArrDraft(submitQID, this.qFields, value, this.currentStep, this.isEdit);
				}
				this.questionnaireService.updateMetaData(this.currentStep, '2.3', herkevGeneri.value);
				let currentQuestion = this.questionnaireService.getQuestion(this.currentStep, '2.3');
				this.questionnaireService.saveData(currentQuestion, [herkevGeneri.value]);
			}
			else {
				this.draft.buildArrDraft(submitQID, this.qFields, value, this.currentStep, this.isEdit)
			}
			this.questionnaireService.sendGA(this.currentStep, this.qID, values);
			this.nextClick(submitQID, values);
			this.submitted = false;

		}
	}

	nextClick(qID, answers) {
		if (answers) {
			this.questionnaireService.updateMetaData(this.currentStep, qID, answers);
			this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
			this.questionnaireService.isActiveEditQuestion = false;
		}
	}

	editQuestionChange(qid) {
		if(this.questionnaireService.isActiveEditQuestion === false){
			this.questionnaireService.isActiveEditQuestion = true;
			this.qID = qid;
			this.setValidators();
			this.setValidatorsArray();
		}
	}

	canOverValidator(qName: string) {
		return (control: AbstractControl): { [key: string]: any } => {
			let step2 = this.questionnaireService.getStepByID("2");
			let getQuestion = this.questionnaireService.getQuestion;
			let loanDetailsStep2Question1Answer = (getQuestion(step2, "1").selectedAnswer[0]);//matara aalvaa
			if (loanDetailsStep2Question1Answer === "11" && control.value === "NO") {
				return { canOverValidator: true };
			}

			return null;
		}
	}

	checkAmount() {
		return (control): { [key: string]: any } => {
			let count = 0;

			for (let i = 0; i < control.length; i++) {
				count += control.controls[i].controls.amount.value;
			}
			let valueMash = control.parent.controls.howMuchYouNeed.value;
			if (control.parent.controls.zakaut.value === 'NO') {
				if (valueMash != count) {
					return { amountNotEquelMash: true };
				}
			}
			if (control.parent.controls.zakaut.value === 'YES') {
				valueMash = valueMash - control.parent.controls.scumZakaut.value;
				if (valueMash != count) {
					return { amountNotEquelMashWithZakaut: true };
				}
			}
		}
	}

	periodValidator() {
		return (control: FormArray): { [key: string]: any } | null => {

			if (!control || control.length === 0) return null;

			const herkev = this.loanDetails.controls["herkevGeneri"].value;
			if (herkev && herkev === '1') return null;

			const tkufaCtrl = this.loanDetails.controls["tkufa"].value;
		
			if (!control || control.length === 0) return null;
		
			const years = Number(tkufaCtrl ? tkufaCtrl : 0) || 0;
			if (!years) return null; // don't block until user chose years
		
			const maxMonths = years * 12;
		
			let hasExact = false;
			let anyEntered = false;
		
			for (let i = 0; i < control.length; i++) {
			const row = control.at(i) as FormGroup;
			const pCtrl = row.get('period');
			const p = Number(pCtrl ? pCtrl.value : 0);
		
			if (p) anyEntered = true;
		
			// every row must be <= Y
			if (p > maxMonths) return { periodMismatch: true };
		
			// at least one row must be == Y
			if (p === maxMonths) hasExact = true;
			}
		
			// If nothing entered yet in rows, don't block
			if (!anyEntered) return null;
		
			return hasExact ? null : { periodMismatch: true };
		};
	}
	  	  	  	  	  
	checkZero() {
		return (control: AbstractControl): { [key: string]: any } => {
			var res = control.value.match("^[0]$");
			if (res) {
				return { zero: true };
			}
		}
	}

	amountValidator(qName: string) {
		return (control: AbstractControl): { [key: string]: any } => {
			this.warnInfo = false;
			let maxAmount = 0;
			let getQuestion = this.questionnaireService.getQuestion;
			let step2 = this.questionnaireService.getStepByID("2");

			//console.log(+(getQuestion(step5,"2").answer.fields[0].answerValue));



			let loanDetailsStep2Question1Answer = (getQuestion(step2, "1").selectedAnswer[0]);//matara aalvaa
			let loanDetailsStep2Question2Answer = (+(getQuestion(step2, "2").answer.fields[0].answerValue));//shoum amashkenta
			let loanDetailsStep2Question3Answer = (getQuestion(step2, "3").selectedAnswer[0]);//dira hiloufit
			let loanDetailsStep2Question4Answer = (getQuestion(step2, "4").selectedAnswer[0]);//keneged nehess kayam
			let loanDetailsStep2Question5Answer = (getQuestion(step2, "5").selectedAnswer[0]);//mitkaven limkor et anehess
			let currentStepQuestion3Answer = +control.value;//chover adira bashouk

			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2" || loanDetailsStep2Question1Answer === "17" || loanDetailsStep2Question1Answer === "7") && loanDetailsStep2Question3Answer === "NO") {
				maxAmount = 0.75;
			}
			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "YES" && loanDetailsStep2Question5Answer === "YES") {
				maxAmount = 0.70;
			}
			if ((loanDetailsStep2Question1Answer === "5" || loanDetailsStep2Question1Answer === "10") && loanDetailsStep2Question3Answer === "NO") {
				maxAmount = 0.70;
			}
			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2" || loanDetailsStep2Question1Answer === "5" || loanDetailsStep2Question1Answer === "10") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "YES" && loanDetailsStep2Question5Answer === "NO") {
				maxAmount = 0.50;
			}
			if ((loanDetailsStep2Question1Answer === "17" || loanDetailsStep2Question1Answer === "7") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "YES") {
				maxAmount = 0.50;
			}
			if (loanDetailsStep2Question1Answer === "11") {
				maxAmount = 0.50;
			}


			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2" || loanDetailsStep2Question1Answer === "17" || loanDetailsStep2Question1Answer === "7") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "NO") {
				maxAmount = 0.75;
			}
			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "NO") {
				maxAmount = 0.75;
			}
			if ((loanDetailsStep2Question1Answer === "5" || loanDetailsStep2Question1Answer === "10") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "NO") {
				maxAmount = 0.70;
			}

			let result = loanDetailsStep2Question2Answer / currentStepQuestion3Answer;


			if (result > maxAmount) {
				switch (maxAmount) {
					case 0.75:
						return { amountValidator75: true };
					case 0.70:
						return { amountValidator70: true };
					case 0.50:
						return { amountValidator50: true };
					default:
						break;
				}

			} else {
				//this.warnInfo = true;
				return null;
			}
			//return null;
		}
	}

	focusToElement(selector: string) {
		const selectedElement = Array.from(document.querySelectorAll(selector));

		if (selectedElement && selectedElement.length > 0) {
			const nowActiveElement = document.activeElement;
			(nowActiveElement as HTMLElement).blur();
			setTimeout(() => (selectedElement[0] as HTMLElement).focus(), 0);
		}
	}

	fixedMinThirdValidator() {
		return (control: FormArray): { [key: string]: any } | null => {
		  if (!control || control.length === 0) return null;

		  const FIXED_CODES = [20, 21, 22, 23]; 
	  
		  let total = 0;
		  let fixedSum = 0;
	  
			for (let i = 0; i < control.length; i++) {
				const row = control.at(i) as FormGroup;
				const amountCtrl = row.get('amount');
				const amount = Number(amountCtrl ? amountCtrl.value : 0) || 0;
				const typeCtrl = row.get('type');
				const typeVal = String(typeCtrl ? typeCtrl.value : '');

				total += amount;
				const FIXED_LABELS = FIXED_CODES.map(n=>{
					const obj = this.maslulimJson.find(item => item["KOD_MASLUL"] === n);
					return obj ? obj["TEUR_MASLUL"] : null;
				})

				const isFixed = Array.from(FIXED_LABELS).some(lbl => typeVal.includes(lbl))
				
				if (isFixed) fixedSum += amount;
			}
		  if (total === 0) return null; 
		  return fixedSum >= total / 3 ? null : { fixedThirdMissing: true };
		};
	}
	
}



// WEBPACK FOOTER //
// ./src/app/loan-details/loan-details.component.ts